import Vue from "vue";
import * as Api from "../../api";

const state = {

}

const getters = {}

const mutations = {
}

const actions = {
  contactAgent({ state, rootState }, { params, callback }) {
    let obj = {
      action: `/api/agent/contact-agent/email/${params.propertyId}`,
      ...params.data
    };
    Vue.http.headers.common = {
      webType: "store",
      token: state.token ? state.token : Utils.loadLocal2("token")
    };
    Api.requestbody(obj).then(resp => {
      if (callback) {
        callback(resp, "contactAgentCallback");
      }
    });
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/contact.js